

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
import { appConfig } from './app/app.config';
import { LicenseManager } from 'ag-grid-enterprise';

if (environment.production) {
  LicenseManager.setLicenseKey(environment.agGridLicenseKey);
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
